import React from "react";

import { default as IconBtn } from "../../../../../../../components/Buttons/IconButton";
import PlusBackgroundIcon from "../../../../../../../images/PlusBackgroundIcon";
import BuyInstrumentModal from "../../PortfolioTradeV2/components/BuyInstrumentModal";
import PortfolioSelectionModal from "../../PortfolioTradeV2/components/PortfolioSelectionModal";

/**
 * Renders the appropriate instrument selection modal based on the action:
 * - create: full instrument search (BuyInstrumentModal) — unless portfolioOnly is forced
 * - edit/delete: portfolio-only selection (PortfolioSelectionModal)
 *
 * Use forcePortfolioOnly=true for payout/switch plans where create also picks from portfolio.
 */
const AddInstrumentDialog = ({
  open,
  onClose,
  portfolioComponents,
  allInstruments,
  instrumentsHandler,
  handleAddItems,
  action,
  withSrri,
  clientSRRI,
  customerId,
  isCustomerApp,
  isVirtual,
  portfolio,
  title,
  portfolioOnly,
}) => {
  if (!open) return null;

  const filteredComponents = (portfolioComponents || []).filter((i) => !!i.isin);

  if (portfolioOnly) {
    return (
      <PortfolioSelectionModal
        title={title}
        onClose={onClose}
        portfolioInstruments={filteredComponents}
        instrumentsHandler={instrumentsHandler}
        onSubmit={(assets) => handleAddItems(action, assets)}
        action={action}
        withSrri={withSrri}
        clientSRRI={clientSRRI}
      />
    );
  }

  return (
    <BuyInstrumentModal
      onClose={onClose}
      portfolio={portfolio}
      transactions={allInstruments}
      instrumentsHandler={instrumentsHandler}
      handleAddItems={(assets) => handleAddItems(action, assets)}
      customerId={customerId}
      isCustomerApp={isCustomerApp}
      isVirtual={isVirtual}
      portfolioInstruments={filteredComponents}
    />
  );
};

export default AddInstrumentDialog;
